import type { trpcConsumerGetCalendarDays } from '@trashlab/api/src/generated/hooks';
import {
  buildCalendarForecastRequirement,
  type CalendarForecastRequirement,
} from '@trashlab/api/src/domains/consumer/types/calendar';

type CalendarDaysInput = typeof trpcConsumerGetCalendarDays.input;

export const buildSitesCalendarForecastRequirement =
  buildCalendarForecastRequirement;

export type SitesShopCalendarProps = {
  tenantId: string;
  compact?: boolean;
  value?: [Date | null, Date | null];
  onChange?: (value: [Date | null, Date | null]) => void;
  daysLimit?: number;
  onDaysOverChange?: (daysOver: number) => void;
  pickupDateOptional?: boolean;
  startRentalFromDeliveryDate?: boolean;
  blockSameDayOrder?: boolean;
  sameDayOrderCutoffTime?: string;
  blockedDaysFromToday?: number;
  countInactiveDaysAsRentalDays?: boolean;
  forecastRequirement: CalendarForecastRequirement;
};

export function buildCalendarForecastInput(
  input: Omit<
    CalendarDaysInput,
    'productId' | 'blockDatesWithoutInventory' | 'showForecastOnHover'
  > &
    CalendarForecastRequirement,
): CalendarDaysInput {
  return input;
}
